import React, { useEffect, createElement } from 'react';
const GTM_ID = 'GTM-THV9TTQ7';
export function GoogleTagManager() {
  useEffect(() => {
    // GTM dataLayer init
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    // GTM head script - append to head directly
    const j = document.createElement('script');
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(j);
    // GTM noscript iframe
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
    return () => {
      if (j.parentNode) j.parentNode.removeChild(j);
      if (noscript.parentNode) noscript.parentNode.removeChild(noscript);
    };
  }, []);
  return null;
}